import { useState, useEffect } from "react";
import { Button } from "semantic-ui-react";
import { useNavigate, useParams } from "react-router-dom";
import { Loading } from "../../components/Loading/Loading";
import { ConsoleStream } from "../../components/ConsoleStream/ConsoleStream";
import { getSubtask } from "../../services/calculationsService";
import "./Subtask.css";
import { ISubtask } from "../../models/subtask";

export const Subtask = () => {
    const navigate = useNavigate();
    const params: { subtaskGuid?: string } = useParams();
    const [subtask, setSubtask] = useState<ISubtask>();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getSubtask(params.subtaskGuid ?? "").then(res => {
            setSubtask(res);
            setLoading(false);
        });
    }, [params.subtaskGuid]);

    return (
        <div id="subtask-container-div-a" className="subtask-page-container">
            <div id="subtask-title-div-a" className="subtask-page-title tsc-blue">
                <h1 id="subtask-page-title">{subtask ? subtask.name : ""}</h1>
                <Button
                    id="button-subtask-a"
                    primary
                    content="Back to list of subtasks"
                    onClick={() =>
                        navigate(
                            `/Calculations/${subtask!.parentGuid}/Tasks/${subtask!.stage}/Subtasks`
                        )
                    }
                />
            </div>
            <div id="subtask-content-div-a" className="subtask-page-content">
                {loading ? <Loading /> : <ConsoleStream taskId={subtask!.id} />}
            </div>
        </div>
    );
};
